module.exports = __webpack_public_path__ + "img/fond-troupeau5test.2973069e.jpg";